import { TableOfContentsItem } from './components/table-of-content'

export const NINJA_LOGO_COLORS = {
  letters: '#2b3749',
  logo: '#3ba1c4',
}

export const articles: Record<string, TableOfContentsItem[]> = {
  authorization: [
    {
      id: '/authorization/overview',
      slug: '/authorization/overview',
      title: 'Overview',
      meta: '',
      type: 'article',
    },
    {
      title: 'Create Applications',
      items: [
        {
          id: '/authorization/create-applications/machine-to-machine-apps',
          slug: '/authorization/create-applications/machine-to-machine-apps',
          title: 'Register Machine-to-Machine Applications',
          type: 'article',
          meta: '',
        },
        {
          id: '/authorization/create-applications/regular-web-apps',
          slug: '/authorization/create-applications/regular-web-apps',
          title: 'Register Regular Web Applications',
          type: 'article',
          meta: '',
        },
        {
          id: '/authorization/create-applications/native-apps',
          slug: '/authorization/create-applications/native-apps',
          title: 'Register Native Applications',
          type: 'article',
          meta: '',
        },
        {
          id: '/authorization/create-applications/single-page-web-apps',
          slug: '/authorization/create-applications/single-page-web-apps',
          title: 'Register Single-Page Web Applications',
          type: 'article',
          meta: '',
        },
      ],
    },
    {
      title: 'Authorization Flows',
      items: [
        {
          id: '/authorization/flows/client-credentials-flow',
          slug: '/authorization/flows/client-credentials-flow',
          title: 'Client Credentials Flow',
          type: 'article',
          meta: '',
        },
        {
          id: '/authorization/flows/authorization-code-flow',
          slug: '/authorization/flows/authorization-code-flow',
          title: 'Authorization Code Flow',
          type: 'article',
          meta: '',
        },
        {
          id: '/authorization/flows/authorization-code-flow-with-proof-key-for-code-exchange-pkce',
          slug: '/authorization/flows/authorization-code-flow-with-proof-key-for-code-exchange-pkce',
          title:
            'Authorization Code Flow with Proof Key for Code Exchange (PKCE)',
          type: 'article',
          meta: '',
        },
        {
          id: '/authorization/flows/implicit-flow',
          slug: '/authorization/flows/implicit-flow',
          title: 'Implicit Flow',
          type: 'article',
          meta: '',
        },
      ],
    },
    {
      title: 'Refresh Tokens',
      id: '/authorization/refresh-tokens',
      slug: '/authorization/refresh-tokens',
      type: 'article',
      meta: '',
    },
  ],
}
